module.exports = __webpack_public_path__ + "static/video-poster-c5eca1b58767e94ff9cf987262b68514.webp";